import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eca4fc18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "distribution-groups-wrapper",
  class: "main-content-wrapper"
}
const _hoisted_2 = { class: "distribution-groups-title grid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title col-3 mt-3" }, "下書き／停止中グループ一覧", -1))
const _hoisted_4 = { class: "distribution-groups-filter grid mt-1" }
const _hoisted_5 = { class: "distribution-groups-list-body mt-3" }
const _hoisted_6 = { class: "p-input-icon-left h-auto box-search" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "list-groups mt-3" }
const _hoisted_9 = { class: "w-full text-right pr-3" }
const _hoisted_10 = { class: "form-check form-switch" }
const _hoisted_11 = { class: "switch-status ml-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "grid mt-3 justify-content-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-question-circle mt-4" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "centered-text mt-5" }, "選択した配信グループの配信を再開しますか?", -1))
const _hoisted_21 = { class: "grid mt-4 mb-3 justify-content-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "ml-3" }, "指定の配信グループの配信を再開致しま した。", -1))
const _hoisted_23 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/warning-logo.png",
  alt: "Warning Logo",
  class: "warning-logo mr-4 ml-2"
}, null, -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 0,
  class: "p-dialog-content"
}
const _hoisted_29 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-full justify-content-center align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo"
  })
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "centered-text mt-4" }, "選択した配信グループは設定不足により、 配信の再開できません!", -1))
const _hoisted_32 = { class: "grid mt-4 mb-3 justify-content-center" }

import { ref, onBeforeMount, computed } from "vue";
import { get, set } from "@vueuse/core";
import { useStore } from "vuex";
import { useToast } from "primevue/usetoast";
import { PageState } from "primevue/paginator";
import Toast from "primevue/toast";
import Chip from "primevue/chip";
import SelectButton from "primevue/selectbutton";
import Checkbox from "primevue/checkbox";
import InputSwitch from "primevue/inputswitch";
import Dialog from "primevue/dialog";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import moment from "moment";

type IColumn = {
  field: string;
  header: string;
  class?: string;
  style?: string;
  icon?: unknown;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'drafts',
  setup(__props) {

const first = ref(0);
const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const searchTerm = ref("");
const toast = useToast();
const dialogVisibleChangeFromStop = ref(false);
const dialogVisibleDoneChangeStatus = ref(false);
const page = ref(0);
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);
const distributionGroups = ref([]);
const checked = true;
const warningChangeStatus = ref(false);
const warningVisible = ref(false);
const changeStatusObject = ref();
const clinicId = ref();
const store = useStore();
const missingSettingDialog = ref(false);
const selectedFilter = ref("all");
const loading = ref(false);
const listChosen = ref([]);

const groupType = [
  { label: "すべて", value: "all" },
  { label: "新規向け", value: "new_user" },
  { label: "再来向け", value: "re_examination" },
  { label: "既存向け", value: "existing" },
  { label: "一斉配信", value: "broadcast_all_in_one" },
  { label: "その他", value: "other_type" },
];

const columns = ref<IColumn[]>([
  { field: "action", header: "", class: "col", style: "max-width: 50px" },
  { field: "status", header: "ステータス", class: "col", style: "font-size: 13px; max-width: 75px " },
  { field: "group_type", header: "カテゴリ", class: "col-2", style: "font-size: 13px; max-width: 100px " },
  {
    field: "name",
    header: "配信名",
    class: "col-2",
    style: "font-size: 13px; max-width: 150px ",
  },
  { field: "send_at", header: "配信予定 日時", class: "col", style: "font-size: 13px; max-width: 110px " },
  { field: "number_of_send", header: "配信回数", class: "col", style: "font-size: 13px; max-width: 75px " },
  { field: "number_of_targets", header: "メッセージ 数", class: "col", style: "font-size: 13px; max-width: 60px" },
  { field: "number_of_delivered", header: "対象ユー ザー数", class: "col", style: "font-size: 13px; max-width: 62px" },
  { field: "opens_rate", header: "開封数/率", class: "col", style: "font-size: 13px" },
  { field: "clicks_rate", header: "クリック数/率", class: "col", style: "font-size: 13px " },
  { field: "number_completed_on_bookings", header: "予約完了数/率", class: "col", style: "font-size: 13px " },
  {
    field: "number_of_canceled",
    header: "予約キャンセル数 /率",
    class: "col",
    style: "font-size: 13px; max-width: 105px",
  },
  { field: "edit", header: "編集", class: "col" },
]);

const onClosedDialog = () => {
  set(warningChangeStatus, false);
  set(dialogVisibleChangeFromStop, false);
  set(dialogVisibleDoneChangeStatus, false);
  set(missingSettingDialog, false);
};

const handleError = (promise: Promise<unknown>) => {
  return promise.then((data: unknown) => [undefined, data]).catch((error: unknown) => [error, undefined]);
};

const onOpenChangeStatusDialog = async (data: Record<string, unknown>) => {
  if (data.status === "stop") {
    set(dialogVisibleChangeFromStop, true);
    set(changeStatusObject, data);
  } else {
    set(missingSettingDialog, true);
  }
};

const onChangeStatus = async () => {
  if (changeStatusObject.value.delivery_type == "immediate_delivery") {
    set(warningChangeStatus, true);
    set(warningVisible, true);
  } else {
    await callChangeStatusApi(changeStatusObject.value.id);
  }
  set(dialogVisibleChangeFromStop, false);
};

const onConfirmSendMessage = async () => {
  await callChangeStatusApi(changeStatusObject.value.id);
  set(warningVisible, false);
};

const callChangeStatusApi = async (distributionGroupId: number) => {
  const params = { clinic_id: clinicId.value };
  const body = { status: "active" };

  const [errorSaveDraft] = await handleError(DistributionGroupService.changeStatus(distributionGroupId, params, body));
  if (errorSaveDraft) {
    notityErrorMsg(toast, "エラーが発生しました");
  } else {
    set(dialogVisibleDoneChangeStatus, true);
    loadDistributionGroups();
  }
};

const onSearch = async (event: Event) => {
  const target = event.currentTarget as HTMLInputElement;
  set(searchTerm, target?.value || "");
  // 検索時はページをリセット
  set(page, 0);
  set(first, 0);
  await loadDistributionGroups();
};

const paginatorParams = computed(() => {
  return {
    term: get(searchTerm),
    page: get(page) + 1, // バックエンドは1ベースのページ番号を期待
    rows: get(rows),
    status: ["draft", "stop"],
    group_type:
      get(selectedFilter) == "all"
        ? ["new_user", "re_examination", "existing", "broadcast_all_in_one", "other_type"]
        : [get(selectedFilter)],
  };
});

const paging = async (fromId: string, { page: newPage, first: newFirst }: PageState) => {
  // 現在のページと同じ場合は何もしない
  if (newPage === get(page)) return;

  // ページ番号を更新
  set(page, newPage);

  // firstの値を更新（PrimeVueから渡された値を使用）
  set(first, newFirst);

  await loadDistributionGroups();
};

const goToNewDistributionGroup = () => {
  RouterUtils.goTo(RouterConstants.NEW_DISTRIBUTION_GROUPS_NAME);
};

const goToGroupLists = () => {
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUP_ROUTER_NAME);
};

const loadDistributionGroups = async () => {
  set(loading, true);
  const { data } = await DistributionGroupService.getDistributionGroups({
    clinic_id: clinicId.value,
    ...get(paginatorParams),
  });

  const { distribution_groups: distributionGroupsData, meta } = get(data);
  distributionGroupsData.forEach((callback: Record<string, unknown>) => {
    callback["view_status"] = callback.status === "draft" || callback.status === "stop";
  });

  const { total_count } = meta;
  set(distributionGroups, distributionGroupsData);
  set(totalCount, get(total_count));
  set(loading, false);
};

const onFilterStatus = async () => {
  await loadDistributionGroups();
};

const deleteDistributionGroup = async () => {
  await DistributionGroupService.destroyDistributionGroups(
    listChosen.value,
    () => {
      notifySuccessMsg(toast, "指定された配布グループが除外されました");
      loadDistributionGroups();
    },
    () => notityErrorMsg(toast, "エラーが発生しました")
  );
  set(warningVisible, false);
};

const onClosedWarningDialog = () => {
  set(warningVisible, false);
  set(warningChangeStatus, false);
};

const editDistribution = (event: Event, templateId: number) => {
  event.stopPropagation();
  RouterUtils.goToWithParams(RouterConstants.EDIT_DISTRIBUTION_GROUP_ROUTER_NAME, { id: templateId });
};

const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};

onBeforeMount(async () => {
  await loadClinicInfo();
  await loadDistributionGroups();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_Button, {
          class: "col-auto ml-auto temp-save-btn mt-3",
          label: "配信グループ一覧",
          onClick: goToGroupLists
        }),
        _createVNode(_component_Button, {
          class: "col-auto mt-3 create-btn ml-3 mb-2",
          label: "配信グループ新規作成",
          onClick: goToNewDistributionGroup
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(SelectButton), {
          modelValue: selectedFilter.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFilter).value = $event)),
          options: groupType,
          optionLabel: "label",
          optionValue: "value",
          class: "mt-5 ml-2 filter-status-btn-container",
          onChange: onFilterStatus
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputText, {
            placeholder: "配信名",
            onKeyup: _withKeys(onSearch, ["enter"])
          }, null, 8, ["onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Paginator, {
            id: "pg-top",
            ref_key: "pgTop",
            ref: pgTop,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            class: "mt-2",
            paginatorId: "pg-top"
          }, null, 8, ["modelValue", "totalRecords", "rows"]),
          _createVNode(Grid, {
            items: distributionGroups.value,
            columns: columns.value,
            loading: loading.value,
            onOnItemClick: _ctx.onItemClick
          }, {
            action: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(Checkbox), {
                  modelValue: listChosen.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((listChosen).value = $event)),
                  inputId: data.id,
                  name: data.id,
                  value: data.id
                }, null, 8, ["modelValue", "inputId", "name", "value"])
              ])
            ]),
            status: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(data.status == "draft" ? "下書き" : "停止中"), 1),
                _createVNode(_unref(InputSwitch), {
                  modelValue: checked,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checked) = $event)),
                  onChange: ($event: any) => (onOpenChangeStatusDialog(data))
                }, null, 8, ["onChange"])
              ])
            ]),
            group_type: _withCtx(({ data }) => [
              _createVNode(_unref(Chip), {
                label: groupType.find(item => item.value == data.group_type)?.label
              }, null, 8, ["label"])
            ]),
            send_at: _withCtx(({ data }) => [
              (data.send_at != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(moment)(data.send_at).locale("ja").format("YYYY年MM月DD日 HH:mm")), 1))
                : _createCommentVNode("", true)
            ]),
            opens_rate: _withCtx(({ data }) => [
              (data.number_of_opens != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(data.number_of_opens) + "/" + _toDisplayString(data.opened_rate) + "%", 1))
                : _createCommentVNode("", true)
            ]),
            clicks_rate: _withCtx(({ data }) => [
              (data.number_of_clicks != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(data.number_of_clicks) + "/" + _toDisplayString(data.click_rate) + "%", 1))
                : _createCommentVNode("", true)
            ]),
            number_completed_on_bookings: _withCtx(({ data }) => [
              (data.number_of_completed_reservations != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(data.number_of_completed_reservations) + "/" + _toDisplayString(data.completed_reservations_rate) + "% ", 1))
                : _createCommentVNode("", true)
            ]),
            number_of_canceled: _withCtx(({ data }) => [
              (data.number_of_reservation_cancellations != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(data.number_of_reservation_cancellations) + "/" + _toDisplayString(data.reservation_cancellations_rate) + "% ", 1))
                : _createCommentVNode("", true)
            ]),
            edit: _withCtx(({ data }) => [
              (data.status == 'draft')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "pi pi-pencil text-green-600 mr-5",
                    onClick: ($event: any) => (editDistribution($event, data.id))
                  }, null, 8, _hoisted_17))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["items", "columns", "loading", "onOnItemClick"]),
          _createVNode(Paginator, {
            id: "pg-bot",
            ref_key: "pgBot",
            ref: pgBot,
            modelValue: first.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((first).value = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            class: "mt-2",
            paginatorId: "pg-bot"
          }, null, 8, ["modelValue", "totalRecords", "rows"]),
          _createVNode(_unref(Toast), { position: "top-center" })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_Button, {
            class: "col-2 black-btn ml-5",
            label: "削除",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (warningVisible.value = true))
          })
        ])
      ])
    ]),
    _createVNode(_unref(Dialog), {
      visible: dialogVisibleChangeFromStop.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisibleChangeFromStop).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-warning border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_19
      ]),
      default: _withCtx(() => [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-1 mr-3",
            label: "キャンセル",
            onClick: onClosedDialog
          }),
          _createVNode(_component_Button, {
            class: "col-3 create-btn ml-4 w-fit-content",
            label: "配信再開",
            onClick: onChangeStatus
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: dialogVisibleDoneChangeStatus.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((dialogVisibleDoneChangeStatus).value = $event)),
      modal: "",
      style: { width: '405px' },
      class: "mx-5 dialog-note border-0",
      draggable: false,
      "show-header": false
    }, {
      default: _withCtx(() => [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_Button, {
            class: "col-6 black-btn",
            label: "配信グループ一覧へ 戻る",
            onClick: onClosedDialog
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: warningVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((warningVisible).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          (!warningChangeStatus.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "これらの配布グループを削除しますか?"))
            : (_openBlock(), _createElementBlock("span", _hoisted_27, "このグループのステータスを変更してもよろしいですか?"))
        ])
      ]),
      default: _withCtx(() => [
        (warningChangeStatus.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_28, " デリバリーグループのステータスを変更すると、グループ内の顧客にすぐにメッセージが送信されます "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_component_Button, {
            class: "col-4 black-btn ml-5",
            label: "戻る",
            onClick: onClosedWarningDialog
          }),
          _createVNode(_component_Button, {
            class: "col-4 confirm-delete-btn ml-5",
            label: "確認する",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (warningChangeStatus.value ? onConfirmSendMessage() : deleteDistributionGroup()))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: missingSettingDialog.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((missingSettingDialog).value = $event)),
      modal: "",
      style: { width: '640px' },
      class: "mx-5 dialog-warning border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_30
      ]),
      default: _withCtx(() => [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn",
            label: "戻る",
            onClick: onClosedDialog
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})